import React, { useState, useEffect } from "react";
import "./TenantWelcomeBannerTablet.scss";
import { FaPlay, FaTimes } from "react-icons/fa";
import { MdWavingHand, MdTouchApp } from "react-icons/md";

const TenantWelcomeBannerTablet = ({ userName, onStartTour, onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a small delay for smooth animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  const handleStartTour = () => {
    setIsVisible(false);
    setTimeout(() => {
      onStartTour();
    }, 300);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      onDismiss();
    }, 300);
  };

  return (
    <div className={`tenant-welcome-banner-tablet ${isVisible ? "visible" : ""}`}>
      <div className="welcome-content-tablet">
        <div className="welcome-header-tablet">
          <div className="welcome-icon-tablet">
            <MdWavingHand />
          </div>
          <div className="welcome-text-tablet">
            <h3>Welcome, {userName}!</h3>
            <p>Ready to explore your comprehensive payment dashboard?</p>
          </div>
          <button className="dismiss-btn-tablet" onClick={handleDismiss}>
            <FaTimes />
          </button>
        </div>
        
        <div className="welcome-body-tablet">
          <p>Take a guided tour to discover:</p>
          <ul>
            <li>
              <MdTouchApp className="feature-icon" />
              Comprehensive payment progress reports
            </li>
            <li>
              <MdTouchApp className="feature-icon" />
              Quick payment links for instant transactions
            </li>
            <li>
              <MdTouchApp className="feature-icon" />
              Detailed transaction history and records
            </li>
            <li>
              <MdTouchApp className="feature-icon" />
              Intuitive navigation between dashboard sections
            </li>
          </ul>
        </div>
        
        <div className="welcome-actions-tablet">
          <button className="tour-btn-tablet" onClick={handleStartTour}>
            <FaPlay />
            Start Interactive Tour
          </button>
          <button className="skip-btn-tablet" onClick={handleDismiss}>
            Skip Tour
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantWelcomeBannerTablet;
